export default __webpack_public_path__ + "static/media/servicejpg2.af7c072a.jpg";